export function extractChatbotAnswer(response: unknown, fallback: string): string {
  const r = response as Record<string, unknown>
  const candidates = [
    r?.answer,
    (r?.data as Record<string, unknown>)?.answer,
    (r?.result as Record<string, unknown>)?.answer,
    ((r?.result as Record<string, unknown>)?.data as Record<string, unknown>)?.answer,
    typeof r?.result === 'string' ? r.result : null,
    typeof r?.data === 'string' ? r.data : null,
  ]
  for (const c of candidates) {
    if (typeof c === 'string' && c.trim()) return c
  }
  return fallback
}
